module.exports = "a {\n  color: #080808;\n  text-decoration: none;\n  font-size: large;\n}\n\n.col-cust{\n  margin-left: 16px;\n  display: inline-block;\n}\n\n.link-text{\n  margin-left:15px;\n  display: inline-block\n}\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/user/user-table/user-table.component.css
// module id = ./src/app/user/user-table/user-table.component.css
// module chunks = main